import { render, staticRenderFns } from "./ChannelMultiselectForm.vue?vue&type=template&id=f1b3e104&scoped=true&"
import script from "./ChannelMultiselectForm.vue?vue&type=script&lang=ts&"
export * from "./ChannelMultiselectForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelMultiselectForm.vue?vue&type=style&index=0&id=f1b3e104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b3e104",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu,VRow,VStepper,VStepperContent,VStepperItems})
